import { Injectable, Injector } from '@angular/core';
import { Namespace } from 'enums-lib';
import { BullhornAuthService } from './bullhorn.auth.service';
import { IAuthService } from './iauthservice';
import { InveniasAuthService } from './invenias.auth.service';
import {SalesforceAuthService} from './salesforce.auth.service';

@Injectable({ providedIn: 'root' })
export class AuthServiceFactory {
  constructor(private injector: Injector) {}

  getAuthService(namespace: string): IAuthService {
    if (namespace === Namespace.invenias) {
      return this.injector.get(InveniasAuthService);
    }

    if (namespace === Namespace.bullhorn) {
      return this.injector.get(BullhornAuthService);
    }

    if (namespace === Namespace.salesforce) {
      return this.injector.get(SalesforceAuthService);
    }

    throw new Error(`No authentication service found for '${namespace}'`);
  }
}
